module.exports = __webpack_public_path__ + "static/media/video-retail-store.ae483f21.mp4";